'use strict';

import { Entity } from '../Entity';

export class AgencyLeadStatus extends Entity {
  protected id;
  protected leadStatusName;
  protected leadStatusDispo;
  protected leadStatusNew;
  protected leadStatusFirst;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.auto;
    this.leadStatusName = data.leadStatusName;
    this.leadStatusDispo = data.leadStatusDispo;
    this.leadStatusNew = data.leadStatusNew;
    this.leadStatusFirst = data.leadStatusFirst;
  }

  public getLeadStatusName() {
    return this.leadStatusName;
  }

  public getLeadStatusDispo() {
    return this.leadStatusDispo;
  }

  public getLeadStatusNew() {
    return this.leadStatusNew;
  }

  public getLeadStatusFirst() {
    return this.leadStatusFirst;
  }
}
